import { Alerta, Botao, Box, TipoAlerta } from "@intechprev/componentes-web";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { LoadingComponent } from "../../components";
import { WebEventoEntidade } from "../../entidades";
import { EventoService } from "../../services";
import { MasterPage, NumFuncionalidade } from "../MasterPage";
import { AvisoLGPD } from "./AvisoLGPD";
import { Slides } from "./Slides";

interface IMatchParams {
  oidEvento: string;
}

interface IMatch {
  params: IMatchParams;
}

interface IRest {
  match?: IMatch;
}

export const Eventos: React.FC<IRest> = ({ ...rest }) => {
  const history = useHistory();

  const [OidEvento, setOidEvento] = useState<number>(0);
  const [Evento, setEvento] = useState<WebEventoEntidade>();
  const [Eventos, setEventos] = useState<Array<WebEventoEntidade>>([]);

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        let oidEvento = Number(rest.match.params.oidEvento);

        if (Number.isNaN(oidEvento))
          oidEvento = 0;

        const eventos = await EventoService.BuscarTodos();
        setEventos(eventos);

        setOidEvento(oidEvento);
      }
      catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        setErro(Error);
      }
      finally {
        setLoading(false);
      }
    })();
  }, [rest.match.params.oidEvento]);

  useEffect(() => {
    (async () => {
      try {
        if (OidEvento > 0) {
          const evento = Eventos.filter(x => x.OID_EVENTO === OidEvento)[0];
          setEvento(evento);
        }
      } catch (e) {
        const err: any = e;
        const Error = err.response ? err.response.data : err;
        setErro(Error);
      }
    })();
  }, [OidEvento, Eventos]);

  return (
    <MasterPage Funcionalidade={NumFuncionalidade.DECLARACAO_IR} {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alerta tipo={TipoAlerta.danger} mensagem={Erro} />}

      {!Loading && !Erro && OidEvento === 0 && <>
        <Box titulo={"Eventos Realizados"}>
          {Eventos.length === 0 && <Alerta tipo={TipoAlerta.info} mensagem={"Nenhum evento disponível no momento."} />}

          {Eventos.length > 0 && <>
            <div>
              <table className={"table table-striped table-sm"}>
                <thead>
                  <tr>
                    <th>{"Nome"}</th>
                    <th>{"Data de Início"}</th>
                    <th>{"Data de Fim"}</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {Eventos.map((evento, index) => {
                    return (
                      <tr key={index}>
                        <td>{evento.TXT_TITULO}</td>
                        <td>{evento.DTA_INI_EVENTO}</td>
                        <td>{evento.DTA_FIM_EVENTO || "-"}</td>
                        <td>
                          <Botao
                            titulo={"Visualizar"}
                            onClick={() => history.push(`/eventos/${evento.OID_EVENTO}`)}
                            usaLoading
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </>}
        </Box>
      </>}

      {!Loading && !Erro && OidEvento > 0 && <>
        <Box titulo={Evento && Evento.TXT_TITULO}>
          <Slides oidEvento={OidEvento} />
        </Box>
      </>}

      <AvisoLGPD />
    </MasterPage>
  );
}